import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
    Form,
} from "antd";
import {
    decodeParamString,
} from "../const/const_functions";
import ReactDOM from 'react-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const StripeCheckoutForm = ({ onSubmit, orderTotalWithEverything, paymentElementOptions, clientSecret, paymentStatus, maxWidth = false }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [form] = Form.useForm();
    const [errorMessage, setErrorMessage] = useState();
    const [loading, setLoading] = useState(false);

    const handleError = async (error) => {
        setLoading(false);
        setErrorMessage(error.message);
    }

    // This function will be called when the form is submitted
    const handleSubmit = async (values) => {
        if (!stripe) {
            return;
        }

        setLoading(true);
        setErrorMessage(null);

        // Trigger form validation and wallet collection
        const { error: submitError } = await elements.submit();
        if (submitError) {
            handleError(submitError);
            return;
        }

        try {
            if (clientSecret && paymentStatus === 'requires_action') {
                const { error: nextError, paymentIntent } = await stripe.handleNextAction({
                    clientSecret
                });

                if (nextError) {
                    handleError(nextError);
                    return;
                }

                onSubmit(paymentIntent.id, { paymentIntent });
                return;
            }
        } catch (error) {
            console.log(error);
            return;
        }

        const { error: confirmationError, confirmationToken } = await stripe.createConfirmationToken({
            elements,
        });

        if (confirmationError) {
            console.log(confirmationError);
            handleError(confirmationError);
            return;
        }

        const { id: tokenId } = confirmationToken;

        onSubmit(tokenId);
        return;
    };

    // Show success message if payment succeeded
    useEffect(() => {
        if (paymentStatus === 'succeeded') {
            // Optionally handle success here or let parent component handle it
        }

        if (paymentStatus !== 'initial') {
            setLoading(false);
        }
    }, [paymentStatus]);


    return (
        <Row justify="center" style={{ paddingTop: 0 }}>
            <Col xl={maxWidth ? 24 : 12} lg={maxWidth ? 24 : 18} md={maxWidth ? 24 : 24}>
                <Form form={form} onFinish={handleSubmit}>
                    <div style={{ borderRadius: '6px', padding: '1px' }}>
                        <PaymentElement options={paymentElementOptions} />
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={!stripe || loading || paymentStatus === 'succeeded'}
                            loading={loading}
                            style={{
                                backgroundColor: '#0570de',
                                color: 'white',
                                width: '100%',
                                fontSize: "14px",
                                fontWeight: 'bold',
                                margin: '10px 0'
                            }}
                        >
                            {loading ? 'Processing...' : paymentStatus === 'requires_action' ? `Action Required: Please Click Again` : `Pay $${orderTotalWithEverything}`}
                        </Button>
                    </div>
                    {errorMessage && (
                        <div style={{ color: '#ff4d4f', marginTop: '10px' }}>
                            {errorMessage}
                        </div>
                    )}
                    {paymentStatus === 'succeeded' && (
                        <div style={{ color: '#52c41a', marginTop: '10px' }}>
                            Payment successful!
                        </div>
                    )}
                </Form>
            </Col>
        </Row>
    );
}

const StripeCardEntryPayment = ({
    clientToken,
    paymentCurrency = 'CAD',
    orderTotalWithEverything,
    makeThePayment,
    clientSecret,
    paymentStatus,
    maxWidth
}) => {
    const [stripePromise, setStripePromise] = useState(null);

    useEffect(() => {
        if (clientToken) {
            const stripePromise = loadStripe(decodeParamString(clientToken));
            setStripePromise(stripePromise)
        }
    }, [clientToken]);

    const formOptions = {
        mode: 'payment',
        amount: (orderTotalWithEverything * 1000),
        currency: paymentCurrency.toLowerCase(),
        paymentMethodCreation: 'manual',
        paymentMethodTypes: ['card'],
        appearance: {
            theme: 'flat',
            // variables: {
            //     colorPrimary: '#0570de',
            //     colorBackground: '#ffffff',
            //     colorText: '#30313d',
            //     colorDanger: '#df1b41',
            //     fontFamily: 'Ideal Sans, system-ui, sans-serif',
            //     spacingUnit: '2px',
            //     borderRadius: '4px',
            // }
        }
    }

    const paymentElementOptions = {
        layout: {
            type: 'tabs',
            defaultCollapsed: false
        },
        fields: {
            billingDetails: {
                address: {
                    mode: 'minimal',
                    country: 'auto',
                    postalCode: 'auto' // This is the correct format to hide postal code
                }
            }
        }
    };

    const onSubmit = async (confirmationToken, nextAction) => {
        makeThePayment({ token: confirmationToken }, false, nextAction);
    }

    return (
        <Elements stripe={stripePromise} options={formOptions}>
            <StripeCheckoutForm
                onSubmit={onSubmit}
                orderTotalWithEverything={orderTotalWithEverything}
                paymentElementOptions={paymentElementOptions}
                clientSecret={clientSecret}
                paymentStatus={paymentStatus}
                maxWidth={maxWidth}
            />
        </Elements>
    )
}

export default StripeCardEntryPayment;